export const companyInfo = {
				
    company:
    {
        name: 'eo ipso',
        organization	: 'eo ipso - Jugendhilfe, GbR',
        ustrnr:'202/5088/2678',
        wirtnr:''
    },		
    motto: 'aus sich  selbst heraus',
    shareholders:[
                      {
                          first:'Stephanie',
                          last:'van der Meulen',
                          email:'vandermeulen@eoipso-jugendhilfe.de',
                          short:'stephanie',
                          title:'Dipl. Sozialarbeiterin',
                          caps:[
                          'Verfahrensbeistand (BAG/BVBE), Umgangspflegschaften',
                          'Kreative Kinder- & Jugendtherapeutin (NIK Bremen)',
                          'Pädagogische Kunsttherapeutin (KatHo NRW)',
                          'Traumasensible Pädagogik'],
                          img:'stephanie.jpg'
                      },
                      {
                          first:'Jennifer',
                          last:'Nohl',
                          email:'nohl@eoipso-jugendhilfe.de',
                          short:'jenny',
                          title:'Dipl. Sozialpädagogin' ,
                          caps:['Kinderschutzfachkraft § 8a SGB VIII',
                         'Verfahrensbeistand (BAG/BVBE), Umgangspflegschaften',
                          'Systemische Familientherapeutin (DGSF)',
                          'Systemische Paartherapeutin'],
                          img:'jenny.jpg'
                      },
                      {
                          first:'Judith',
                          last:'Zimmermann-Hardt',
                          email:'zimmermann-hardt@eoipso-jugendhilfe.de',
                          short:'judith',
                          title:'Dipl. Sozialarbeiterin', 
                          caps:['Dipl. Sozialpädagogin',
                          'Kinderschutzfachkraft § 8a SGB VIII', 
                          'Verfahrensbeistand (BAG/BVBE), Umgangspflegschaften', 
                          'Pädagogische Kunsttherapeutin (KatHo NRW)',
                          'Traumasensible Pädagogik'],
                         img:'judith.jpg'
                      }
                  
                  ],
    
    address : {
        street : 'Alter Markt 11',
        zip : '52222',
        city : 'Stolberg (Rheinland)',
        email : 'info@eoipso-jugendhilfe.de',
        tel : '+49 2402 9967900',
        fax : ''
    }
        
          
    };